module.exports = __webpack_public_path__ + "static/img/logoThree.bafa155.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageThree/logoThree.png
// module id = fsBu
// module chunks = 0